export default __webpack_public_path__ + "fonts/color_NewEra.9f9bee00bc9dc338915b1437fe264be6.png";